export const forEachTree = <T extends { [x: string | number]: any }>(
  array: T[],
  callback: (item: T, level: number, index: number) => void,
  nestedKey = 'children',
) => {
  const iterate = (arr: T[], level = 0) => {
    let i = 0;
    const { length } = arr;

    while (i < length) {
      const item = arr[i];
      const children = item[nestedKey];

      callback(item, level, i);

      if (children?.length > 0) {
        iterate(children, level + 1);
      }

      i++;
    }
  };

  iterate(array);
};
